import axios from "../axiosConfig";
import { BASE_SERVER_URL } from "../sampleData";
import { getBranding, primeBranding } from "./brandingStore";

/* ------------------------------------------------------------------ *
 * Branding endpoints (Rays-Florist-Server, /businesses):
 *
 *   GET  /businesses/my              -> data: [{ id, name, code, branding }]
 *   GET  /businesses/branding        -> data: { theme, logo } | null
 *   POST /businesses/branding        -> body: { theme, logo } (partial ok),
 *                                       data: the whole saved doc
 *   POST /businesses/branding/reset  -> data: null
 *
 * The per-business calls name their business with a `business-id` header,
 * so they act on the business passed in, not whatever the token says.
 * Every response is primed into the synchronous store, so brandFor(), the
 * print pages and the :root theme pick it up without a loading state.
 *
 * The Settings page reads the { data: { status, response } } shape, with
 * `response` the resolved { theme, logo } (defaults filled in).
 * ------------------------------------------------------------------ */

const idOf = (b) => (b ? b.id || b.business_id || null : null);
const inBusiness = (business) =>
  idOf(business) ? { headers: { "business-id": String(idOf(business)) } } : {};

const resolved = (business) => {
  const { theme, logo } = getBranding(business);
  return { theme, logo };
};
const ok = (business) => ({ data: { status: "success", response: resolved(business) } });
const failed = (business, err, fallback) => ({
  data: {
    status: "error",
    message:
      (err && err.response && err.response.data && err.response.data.message) || fallback,
    response: resolved(business),
  },
});

/** Primes every business the signed-in person belongs to. */
export function loadAllBranding() {
  return axios
    .get(`${BASE_SERVER_URL}/businesses/my`)
    .then((res) => {
      ((res.data && res.data.data) || []).forEach((b) => primeBranding(b, b.branding || null));
    })
    .catch(() => {});
}

export function fetchBranding(business) {
  return axios
    .get(`${BASE_SERVER_URL}/businesses/branding`, inBusiness(business))
    .then((res) => {
      primeBranding(business, (res.data && res.data.data) || null);
      return ok(business);
    })
    .catch((err) => failed(business, err, "Couldn't load branding."));
}

export function updateBranding(business, patch) {
  return axios
    .post(`${BASE_SERVER_URL}/businesses/branding`, patch || {}, inBusiness(business))
    .then((res) => {
      primeBranding(business, (res.data && res.data.data) || null);
      return ok(business);
    })
    .catch((err) => failed(business, err, "Couldn't save branding."));
}

export function resetBranding(business) {
  return axios
    .post(`${BASE_SERVER_URL}/businesses/branding/reset`, {}, inBusiness(business))
    .then(() => {
      primeBranding(business, null);
      return ok(business);
    })
    .catch((err) => failed(business, err, "Couldn't reset branding."));
}
